module.exports = __webpack_public_path__ + "img/Frame1321314799@2x.3d4bc0a5.png";